export default __webpack_public_path__ + "static/media/Sleeping2.5f7e35bc.svg";